import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { ColumnFilterState } from '@shared/modules/prime-grid-filters/models/column-filter-state';
import { ColumnFilterDefinition } from '../../models/column-filter-definition';
import { BaseFilter } from './base-filter';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultFilterComponent<T> extends BaseFilter<T> implements OnInit {
  filterColumn = input.required<ColumnFilterDefinition>();
  filterChanged = output<ColumnFilterState<T>>();
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    super();
    this.updateFilter
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: ColumnFilterState<T>) => {
        this.filterChanged.emit(value);
      });
  }

  ngOnInit(): void {
    this.filterDefinition.set(this.filterColumn());
    const filterColumn = this.selectedFilter();
    filterColumn.build(this.filterColumn());
    this.loadFilterComponent(this.checkAndSetSessionValue.bind(this));
    this.checkDisableState();
  }
}
